'use client';

import { Fragment } from 'react';

import { getOrdinalSuffix } from '@/modules/apr/profile/utils';
import { getMedalists } from '@/modules/rankings/ppr/helpers';
import { MedalistDisplay } from '@/modules/rankings/ppr/ranking-history/MedalistDisplay';
import { PWRMatchInfo } from '@/modules/rankings/ppr/ranking-history/PWRMatchInfo';
import { PWRResultsContainer } from '@/modules/rankings/ppr/ranking-history/PWRResultsContainer';
import { PWRScoresDetails } from '@/modules/rankings/ppr/ranking-history/PWRScoresDetails';
import { TournamentEventDetails } from '@/modules/rankings/ppr/types';

interface PWRMatchCardProps {
  event: TournamentEventDetails;
  playerName: string;
  isExpanded?: boolean;
  tournamentUuid: string;
}

export function EventMatchCard({
  event,
  playerName,
  isExpanded,
  tournamentUuid,
}: PWRMatchCardProps) {
  return (
    <div className='rounded-lg border border-gray-200'>
      {isExpanded ? (
        <>
          <div className='border-b border-gray-200 text-sm p-3 bg-[#F3F0FF]'>
            {(() => {
              const medalists = getMedalists(event, playerName);
              const half = Math.ceil(medalists.length / 2);
              const left = medalists.slice(0, half);
              const right = medalists.slice(half);
              return (
                <div className='flex flex-col sm:flex-row sm:justify-between'>
                  <div className='flex flex-col text-gray-700'>
                    {left.map((m) => (
                      <Fragment key={m.label}>
                        <MedalistDisplay
                          label={m.label}
                          name={m.name}
                          isPlayer={m.isPlayer}
                          playerName={m.playerName}
                        />
                      </Fragment>
                    ))}
                  </div>
                  <div className='flex flex-col text-gray-700 sm:items-end'>
                    {right.map((m) => (
                      <Fragment key={m.label}>
                        <MedalistDisplay
                          label={m.label}
                          name={m.name}
                          isPlayer={m.isPlayer}
                          playerName={m.playerName}
                        />
                      </Fragment>
                    ))}
                    {event.notInTopFour ? (
                      <p className='mt-1'>
                        {`${event.place}${getOrdinalSuffix(String(event.place))} place`}
                      </p>
                    ) : null}
                  </div>
                </div>
              );
            })()}
          </div>

          {event.matches.map((match) => (
            <div
              key={match.matchUuid}
              className='flex min-h-[128px] flex-col sm:flex-row border-b border-gray-200'
            >
              <PWRMatchInfo match={match} />
              <PWRScoresDetails match={match} playerName={playerName} />
              <PWRResultsContainer match={match} tournamentUuid={tournamentUuid} />
            </div>
          ))}
        </>
      ) : null}
    </div>
  );
}
